import React from "react";
import styles from "../Widget.module.css";
import style from "./socialLinks.module.css";
import {
  FaPhone,
  FaFacebookF as Fb,
  FaInstagram as Insta,
  FaTwitter as Twitter,
  FaLinkedinIn as LinkedIn,
} from "react-icons/fa";
import { MdMail as Mail } from "react-icons/md";

export default function SocialLinks() {
  return (
    <div>
      <div className={style.titleDiv}>
        <h2 className={styles.widgetTitle}>WE ARE EVERYWHERE</h2>
      </div>
      <div className={style.listDiv}>
        <ul className={style.lists}>
          <li className={style.list}>
            <div className={style.listItem}>
              <div className={style.iconDiv}>
                <FaPhone className={style.icon} />
              </div>
              <h1 className={style.iconText}>+1 (647) 548-7866</h1>
            </div>
          </li>
          <li className={style.list}>
            <div className={style.listItem}>
              <div className={style.iconDiv}>
                <FaPhone className={style.icon} />
              </div>
              <h1 className={style.iconText}>+60-11-2323-4533</h1>
            </div>
          </li>
          <li className={style.list}>
            <div className={style.listItem}>
              <div className={style.iconDiv}>
                <Mail className={style.icon} />
              </div>
              <h1 className={style.iconText}>info@invozone.com</h1>
            </div>
          </li>
        </ul>
      </div>
      <div className={style.socialLinks}>
        <h6 className={style.socialHeading}>FOLLOW US HERE</h6>
        <div className={style.socialLinksInner}>
          <div className={style.linkInnerMain}>
            <div className={style.singLinkDiv}>
              <a
                className={style.socialLink}
                href="https://www.facebook.com/InvoZone1"
              >
                <Fb className={style.socialLinkIcon1} />
              </a>
            </div>
          </div>
          <div className={style.linkInnerMain}>
            <div className={style.singLinkDiv}>
              <a
                className={style.socialLink}
                href="https://twitter.com/invozone"
              >
                <Twitter className={style.socialLinkIcon2} />
              </a>
            </div>
          </div>
          <div className={style.linkInnerMain}>
            <div className={style.singLinkDiv}>
              <a
                className={style.socialLink}
                href="https://www.linkedin.com/authwall?trk=ripf&trkInfo=AQH3QViz2ouR9AAAAXGbmkFwkUsu4VDRayz7yw6trkvYtlNej5JWJcWSqngk2ksOwQcQR5vWQTFcoUnslqXGPHiPzMnA2UaOgtQ6b7o84TTCezxWh11au1cjQBROk3YSLHVLekc=&originalReferer=https://dev.invozone.com/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Finvozone"
              >
                <LinkedIn className={style.socialLinkIcon3} />
              </a>
            </div>
          </div>
          <div className={style.linkInnerMain}>
            <div className={style.singLinkDiv}>
              <a
                className={style.socialLink}
                href="https://www.instagram.com/invozone/"
              >
                <Insta className={style.socialLinkIcon4} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
